<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    search>
                        <template #filters>
                            <div class="row align-items-end">
                                <div class="col-md-5">
                                    <label class="form-label">Tarih Aralığı</label>
                                    <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>        
                                </div>
                                <div class="col-md-5">
                                    <label class="form-label">Plasiyer</label>
                                    <v-select-list :options="salesman" label="Visual" v-model="sm" placeholder="Plasiyer"></v-select-list>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-secondary" v-on:click="filter">Filtrele</button>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
                                </div>
                            </div>
                            
                        </template>
                        <template #custom-html>
                            <div class="row px-1 py-0">
                                <div class="col-md-6 mb-1">
                                    <v-stats-box text="Tahsilat Toplamı" variant="success" icon="currency_lira" :value="totalAmount || '0,00'" ></v-stats-box>
                                </div>
                            </div>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VStatsBox from '@/components/VStatsBox.vue'
import { PaymentApi } from '@/api/payment'
import moment from 'moment'
import { UserApi } from '@/api/user'
export default {
    components:{
        BCard,
        VStatsBox
    },
    data(){
        return {
            filterData:{
                StartDate :moment().startOf('month').format('YYYY-MM-DD'),
                EndDate :moment().endOf('month').format("YYYY-MM-DD"),
                PlasiyerId :null,
            },
            dateRange:null,
            fields:[
                {name:'Kod',key:'PlasiyerCode',thClass:'w-15',tdClass:'text-nowrap'},
                {name:'Plasiyer',key:'PlasiyerName',thClass:'w-25',tdClass:'text-nowrap'},
                {name:'Gün',key:'DateStr',thClass:'w-15',tdClass:'text-nowrap'},
                {name:'Toplam Alınan Ödeme',key:'TotalAmountStr',thClass:'w-45',tdClass:'text-nowrap'},
            ],
            salesman:[],
            totalAmount:null
        }
    },
    mounted(){
        this.getSalesman()
        this.getTotalAmountByFilter()
    },
    methods:{
        getTotalAmountByFilter(){
            PaymentApi.DailyStatsByUserTotalAmount({
                ...this.filterData
            }).then(res => {
                this.totalAmount = res.data.Message
            })
        },
        getCurrentMonthDateRange(){
            let date = new Date();
            let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [firstDay,lastDay]
        },
        getSalesman(){
            UserApi.SalesmanList().then(res=>{
                this.salesman = res.data.Data?.map(s=>{
                    return {
                        ...s,
                        Visual:`${s.FullName } - ${s.SalesPersonCode}`
                    }
                })
                this.salesman.unshift({Id:null,Visual:'Tümü',SalesPersonCode:null})
            })
        },
        clearForm(){
            this.filterData.PlasiyerId = null
            this.filterData.StartDate = moment().startOf('month').format('YYYY-MM-DD')
            this.filterData.EndDate = moment().endOf('month').format("YYYY-MM-DD")
        },
        filter(){
            this.getTotalAmountByFilter()
            this.$refs.table.refresh()
        },
        provider(){
            return PaymentApi.DailyStatsByUser({
                ...this.filterData
            })
        }
        
    },
    
    computed:{
        date:{
            get:function(){
                return [this.filterData.StartDate,this.filterData.EndDate].filter(d=>d != null)
            },
            set:function(val){
                this.filterData.StartDate = val[0] || null
                this.filterData.EndDate = val[1] || null
            }
        },
        sm:{
            get:function(){
                return this.salesman.find(r=>r.Id == this.filterData?.PlasiyerId)
            },
            set:function(value){
                this.filterData.PlasiyerId = value?.Id || null
            }
        }
    }
    
}
</script>

<style>

</style>